// src/pages/UsersTab.js
import React, { useEffect, useState } from 'react';
import apiClient from '../api/apiClient.js';
import { Button, TextField, List, ListItem, Typography, Snackbar } from '@mui/material';

function UsersTab({ orgId, isAdmin }) {
  const [users, setUsers] = useState([]);
  const [inviteEmail, setInviteEmail] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [successOpen, setSuccessOpen] = useState(false);

  useEffect(() => {
    if (!isAdmin) return; // Only fetch if admin
    apiClient
      .get(`/organizations/${orgId}/users`)
      .then((res) => setUsers(res.data))
      .catch((err) => setError(err.response?.data?.message || 'Error'));
  }, [orgId, isAdmin]);

  const handleInvite = async () => {
    if (!inviteEmail) return;
    try {
      await apiClient.post(`/organizations/${orgId}/invite`, {
        email: inviteEmail,
        roleName: 'User',
      });
      setSuccess('User invited!');
      setSuccessOpen(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Invite failed');
    }
  };

  if (!isAdmin) {
    return <Typography>You do not have permission to manage users.</Typography>;
  }

  return (
    <div>
      <Typography variant="h6">Users in Org {orgId}</Typography>
      {error && <Typography color="error">{error}</Typography>}
      <List>
        {users.map((u) => (
          <ListItem key={u.id}>{u.email}</ListItem>
        ))}
      </List>
      <TextField
        label="Invite Email"
        variant="outlined"
        value={inviteEmail}
        onChange={(e) => setInviteEmail(e.target.value)}
      />
      <Button variant="contained" onClick={handleInvite}>
        Invite
      </Button>
      <Snackbar
        open={successOpen}
        onClose={() => setSuccessOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        message={success}
        ContentProps={{
          sx: {
            color: '#ffffff',
            backgroundColor: 'primary.main',
            textAlign: 'center'
          }
        }}
      />
    </div>
  );
}

export default UsersTab;
